export const EDITOR_MODES = Object.freeze({
  CANVAS: "canvas",
  NOTE: "note",
});

export const EDITOR_MODE_OPTIONS = Object.freeze([
  {
    label: "Note",
    value: EDITOR_MODES.NOTE,
  },
  {
    label: "Canvas",
    value: EDITOR_MODES.CANVAS,
  },
]);
